function Testimonies(){
    return(
        <div className="testimony_page">
            <div className="testimony_container">
                <h2 className="testimony_title">Testimonies</h2>
                
                <h3>&#127807;Name: Kathleen </h3>

                <p>
                Summary: Kathleen Munro, a Youth Network Ambassador, shares her experience learning about her panic attacks and how to manage them.
                This post is part of a blog series dedicated to sharing personal stories, journeys, and insights about mental health and anxiety from members of our community.
                <br/>
                <a href="https://www.anxietycanada.com/articles/this-is-how-it-feels-to-live-with-a-panic-disorder/" target="_blank" rel="noreferrer">Kathleen's Blog</a>
                </p>

                <h3>&#127807;Name: Tanya</h3>

                <p>
                Summary: Tanya J. Peterson, MS, NCC, a counselor living with anxiety, writes this blog geared toward others going through similar experiences. Her writing expertly mixes the personal and professional, with topics ranging from causes and stigmas to checklists for controlling anxiety and panic attacks. The guest posts offer another perspective on anxiety disorders, making this a blog with a lot of insight. Tanya has covered a variety of topics, including insomnia and anxiety, stress eating, and anxious memories.
                <br/>
                <a href="https://www.healthyplace.com/blogs/anxiety-schmanxiety" rel="noreferrer" target="_blank">Tanya's Blog</a>
                </p>
                
                <h3>&#127807;Name: Meredith</h3>
                
                <p>
                Summary: Meredith Arthur started this blog after being diagnosed with Generalized Anxiety Disorder and wanting to find more treatment options for her chronic migraines. “Diagnosis in hand, I searched and searched but found nothing online that spoke to my physical experience of stress, overthinking, and anxiety,” she writes. She also has a podcast on the topic.
                <br/>
                <a href="https://bevoya.com/blog" target="_blank" rel="noreferrer">Meredith's Blog</a>
                </p>
            </div>

        </div>
    )
}
    


export default Testimonies